import React from "react";
var __jsx = React.createElement;
import TableEditor from './TableEditor';
function TableEditorAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(TableEditor, {
    tables: entry === null || entry === void 0 ? void 0 : entry.tableEditor,
    anchorLink: entry.anchorLink
  });
}
export default TableEditorAdapter;